import {useEffect } from "react";
import * as tf from "@tensorflow/tfjs";
import { useDetect } from "../contexts/DetectContext";
import { useNavigate } from "react-router";
import {useSelector,useDispatch } from "react-redux";
import { setIsLoading, setMessage,setCurrentCityName, setCurrentModelSize  } from "../features/modelSlice";
import { toast } from "react-toastify";

export default function useModel(cityName, modelSize) {
    const {setModel} = useDetect(); 
    const dispatch = useDispatch();
    const { currentCityName, currentModelSize } = useSelector((state) => state.model);
    
    const navigate = useNavigate();

    // Load the TFJS model when the component mounts
    useEffect(() => {
        const loadTfjsModel = async () => {
            if (cityName === "" || modelSize === "") {
                return; // Skip loading if cityName or modelSize is empty
            }
            try {
                dispatch(setIsLoading(true));
                dispatch(setMessage(`${cityName} || ${modelSize} Model Loading...`));
                await tf.setBackend("webgl");
                await tf.ready(); // Ensure the backend is ready
                const modelUrl = `${process.env.PUBLIC_URL}/models/${cityName}/${modelSize}/model.json`;
                const loadedModel = await tf.loadGraphModel(modelUrl);
                setModel(loadedModel);
                dispatch(setMessage(`❌ ${cityName} || ${modelSize} Model loaded Successfully...`));
                toast.success(`✅ ${cityName} || ${modelSize} Model loaded Successfully...`);
            } catch (error) {
                console.error("Error loading model:", error);
                // alert(`${cityName} || ${modelSize} Model can not be loaded!!...`);
                dispatch(setMessage(`❌ ${cityName} || ${modelSize} Model can not be loaded!!...`));
                toast.error(`❌ ${cityName} || ${modelSize} Model can not be loaded!!...`);
                navigate("/"); // Redirect to home page if model fails to load
            } finally {
                dispatch(setIsLoading(false));
            }
        };
        if (cityName !== currentCityName || modelSize !== currentModelSize) {
            loadTfjsModel();
            dispatch(setCurrentCityName(cityName));
            dispatch(setCurrentModelSize(modelSize));
        }
    }, [cityName,modelSize,currentCityName,currentModelSize,dispatch,navigate,setModel]);
    // cityName, modelSize, navigate,  setModel, currentCityName, currentModelSize, setCurrentModelSize, setCurrentCityName
}